export enum MerchantAccountType {
    Default,
    Cashnet
}